/**
 * Quantity (e.g. number of shares) in numeric form or relative size.
 * tag: 27
 * @readonly
 * @enum {string} (String)
 */
export enum IOIQty {
  /** Small */
  Small = 'S',
  /** Medium */
  Medium = 'M',
  /** Large */
  Large = 'L',
  /** Undisclosed Quantity */
  UndisclosedQuantity = 'U',
}
